import { Action } from "redux";
import AppAction from "@my-dld/actions";
import { ProjectProperty, PropertiesWithProject } from "@eres/ejari-api/Entity/LeasedProperties";
import { LeasedPropertySearch } from "@eres/ejari-api/IApi";
import { LeasedProjectSearchState } from "@eres/ejari-web/component/Leased/LeasedProjectSearch";

export interface LeasedDataState {
	searchState?: LeasedProjectSearchState;
	propertySearch?: LeasedPropertySearch;
	projects?: PropertiesWithProject[];
	project?: PropertiesWithProject;
	properties?: ProjectProperty[];
	property?: ProjectProperty;
	units?: ProjectProperty[];
}

export const defaultState: LeasedDataState = {};

export enum LeasedDataAction {
	LEASED_CLEAR_DATA = "LEASED_CLEAR_DATA",
	LEASED_UPDATE_STATE = "LEASED_UPDATE_STATE",
}

export type LeasedAction =
	Action<AppAction.USER_LOGGED_OUT> |
	Action<LeasedDataAction.LEASED_CLEAR_DATA> |
	Action<LeasedDataAction.LEASED_UPDATE_STATE> & { payload?: Partial<LeasedDataState> };

export function LeasedDataReducer( state = defaultState, action: LeasedAction ) {
	switch ( action.type ) {
		case LeasedDataAction.LEASED_CLEAR_DATA:
			return {
				...defaultState
			};

		case LeasedDataAction.LEASED_UPDATE_STATE:
			return {
				...state,
				...action.payload,
			};

		case AppAction.USER_LOGGED_OUT:
			return { ...defaultState };

		default:
			return state;
	}
}
